import { settings } from '@/variables.js'
import axios from 'axios'

export const teamModule = {
  namespaced: true,
  state: {
    title: 'The GI Team',
    content: '',
    members: [],
    memberAnimations: {}
  },
  getters: {},
  mutations: {
    setTeam (state, team) {
      state.members = team
    },
    setTitle (state, title) {
      state.title = title
    },
    setContent (state, content) {
      state.content = content
    },
    setMemberAnimations (state, animations) {
      state.memberAnimations = animations
    }
  },
  actions: {
    getTeam (context, team) {
      axios
        .get(settings.jsonUrl + 'wp/v2/pages?slug=wie-wij-zijn')
        .then(response => {
          let data = response.data[0]
          let members = []
          // let animationMembers = []
          data.acf.afdeling.forEach(afdeling => {
            afdeling.medewerker.forEach(member => {
              members.push(member)
              // if (member.slug) {
              //   animationMembers.push(member.slug)
              // }
            })
          })

          context.commit('setTeam', members)
          context.commit('setTitle', data.title.rendered)
          context.commit('setContent', data.excerpt.rendered)
          // context.dispatch('getMemberAnimations', animationMembers)
        })
        .catch(error => console.log(error))
    },
    getMemberAnimations (context, team) {
      let memberAnimations = {}
      // let total = team.length
      // let processed = 0
      // team.forEach(slug => {
      //   import('@/assets/animations/' + slug + '.json')
      //     .then(response => (memberAnimations[slug] = response.default))
      //     .then(function () {
      //       if (total === ++processed) {
      //         context.commit('setMemberAnimations', memberAnimations)
      //       }
      //     })
      // })
      import('@/assets/animations/micha.json').then(response => (memberAnimations['micha'] = response.default))
      import('@/assets/animations/wendy.json').then(response => (memberAnimations['wendy'] = response.default))
      context.commit('setMemberAnimations', memberAnimations)
    }
  }
}
